const cashInOutActionTypes = {
  GET_REASON_CODE_START: "GET_REASON_CODE_START",
  GET_REASON_CODE_SUCCESS: "GET_REASON_CODE_SUCCESS",
  GET_REASON_CODE_FAILED: "GET_REASON_CODE_FAILED",
  GET_EMPLOYEES_START: "GET_EMPLOYEES_START",
  GET_EMPLOYEES_SUCCESS: "GET_EMPLOYEES_SUCCESS",
  GET_EMPLOYEES_FAILED: "GET_EMPLOYEES_FAILED",
  GET_WAREHOUSE_START: "GET_WAREHOUSE_START",
  GET_WAREHOUSE_SUCCESS: "GET_WAREHOUSE_SUCCESS",
  GET_WAREHOUSE_FAILED: "GET_WAREHOUSE_FAILED",
  GET_POINT_OF_SALE_START: "GET_POINT_OF_SALE_START",
  GET_POINT_OF_SALE_SUCCESS: "GET_POINT_OF_SALE_SUCCESS",
  GET_POINT_OF_SALE_FAILED: "GET_POINT_OF_SALE_FAILED",
  GET_SESSION_USER_START: "GET_SESSION_USER_START",
  GET_SESSION_USER_SUCCESS: "GET_SESSION_USER_SUCCESS",
  GET_SESSION_USER_FAILED: "GET_SESSION_USER_FAILED",
  GET_STORE_REGIONS_START: "GET_STORE_REGIONS_START",
  GET_STORE_REGIONS_SUCCESS: "GET_STORE_REGIONS_SUCCESS",
  GET_STORE_REGIONS_FAILED: "GET_STORE_REGIONS_FAILED",
};

export default cashInOutActionTypes;
